module.exports = __webpack_public_path__ + "img/work2020gif.a2c3d095.gif";